module.exports = __webpack_public_path__ + "img/shareImg3.b8b78844.png";